import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {BaseFillDataFormComponent} from '../../widgets/form-section/base-fill-data-form-component';
import {CustomValidators} from '../../core/validator/custom-validators';

@Component({
  selector: 'app-publication-item',
  templateUrl: './publication-item.component.html',
})
export class PublicationItemComponent extends BaseFillDataFormComponent implements OnInit, OnDestroy {

  publicationForm: FormGroup;

  constructor() {
    super();
  }

  ngOnInit() {
    this.createForm();
  }

  private createForm() {
    this.publicationForm = new FormGroup({
      'publicationName': new FormControl('', CustomValidators.notEmpty),
      'publicationDescription': new FormControl(''),
      'publicationDescriptionEn': new FormControl(''),
      'publicationDate': new FormControl('', CustomValidators.validateDateFormats)
    });
    this.parentForm.addControl('publicationForm' + this.formIndex, this.publicationForm);
  }

  ngOnDestroy(): void {
    this.parentForm.removeControl('publicationForm' + this.formIndex);
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/network/publication-item/publication-item.component.ts